import firebase from 'firebase'

export default {
  data () {
    return {
      twitterMaxLen: 140,
      twitterDMmaxLen: 9990,
      // twitterAuth: null,
      targetScreenName: '',
      screenNameSearchResult: {},
      isScreenNameDone: false
      // isTwitter: false
    }
  },

  created () {
  },

  mounted () {
  },

  computed: {
  },

  filters: {
  },

  watch: {
  },

  methods: {
    getTwitterAuth () {
      const self = this
      const authRef = firebase.firestore().collection('/users/' + this.user.userId + '/auth')
      // const now = this.timestamp()
      let recv = []

      console.log('getTwitterAuth')

      authRef.where('provider', '==', 'twitter').get()
        .then(snapshot => {
          if (snapshot.size > 0) {
            for (let i = 0; i < snapshot.size; i++) {
              recv[i] = snapshot.docs[i].data()
            }
            // とりあえずアカウント１つとしておく
            self.twitterAuth = recv[0]
            self.isTwitter = true
          }
        })
        .catch(err => {
          console.log('getTwitterAuth Error: ', err)
        })
    },

    delTwitterAuth (obj) {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.user.userId)
      const authRef = userRef.collection('auth')

      this.$options.buttonLabels = ['キャンセル', '続行']
      this.$ons.notification.confirm('削除しますか？', this.$options)
        .then(response => {
          if (response > 0) {
            authRef.doc(obj.profileIdStr).delete()
            .then(function () {
              console.log('Deleted twitter auth!')
              self.twitterAuth = null
              self.isTwitter = false
            })
            .catch((err) => {
              console.log('Error delTwitterAuth!: ', err)
              self.spinning = false
              self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
            })
          }
        })
    },

    searchScreenName (screenName) {
      const self = this
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('twitterSearchScreenName')

      console.log('screenName: ', screenName)
      if (screenName === '') {
        self.$ons.notification.alert('スクリーンネームを入力してください。')
        return
      }

      const data = {
        accessToken: this.twitterAuth.accessToken,
        accessTokenSecret: this.twitterAuth.accessTokenSecret,
        screenName: screenName
      }

      this.sendLoading = true
      onCall(data)
      .then((result) => {
        console.log('searchScreenName result! ', result)
        this.screenNameSearchResult = result.data
        self.sendLoading = false
      })
      .catch(function (err) {
        console.log('searchScreenName: ', err)
        self.sendLoading = false
        self.$ons.notification.alert('送信エラー！<br>', err)
      })
    },

    setDMparams (params) {
      this.inData.params = {
        name: params.name,
        screenName: params.screen_name,
        id: params.id,
        idStr: params.id_str,
        icon: params.profile_image_url_https
      }
      this.isScreenNameDone = true
    },

    testTweet () {
      const self = this
      const getNum = firebase.app().functions('asia-northeast1').httpsCallable('testTweetOnCall')

      this.inData.userId = this.user.userId
      if (this.inData.content.length === 0) {
        self.$ons.notification.alert('投稿内容を入力してください。')
        return
      }
      if (this.inData.content.length > this.twitterMaxLen) {
        self.$ons.notification.alert('文字数は　' + this.twitterMaxLen + '　以下にしてください。')
        return
      }

      const data = {
        userId: this.inData.userId,
        messageId: this.inData.id,
        content: this.inData.content,
        accessToken: this.twitterAuth.accessToken,
        accessTokenSecret: this.twitterAuth.accessTokenSecret,
        attachments: this.inData.attachments
      }

      this.sendLoading = true
      getNum(data)
      .then((result) => {
        console.log('Test Tweet Succsess! ', result)
        self.sendLoading = false
        self.$ons.notification.alert('投稿しました！<br><br>Twitterアカウントのタイムラインを<br>確認してください。')
      })
      .catch(function (err) {
        console.log('Error Test Tweet: ', err)
        self.sendLoading = false
        self.$ons.notification.alert('送信エラー！<br>', err)
      })
    },

    testDM () {
      const self = this
      const onCall = firebase.app().functions('asia-northeast1').httpsCallable('twitterDMtestOnCall')

      this.inData.userId = this.user.userId
      const data = {
        userId: this.inData.userId,
        messageId: this.inData.id,
        content: this.inData.content,
        accessToken: this.twitterAuth.accessToken,
        accessTokenSecret: this.twitterAuth.accessTokenSecret,
        attachments: this.inData.attachments,
        params: this.inData.params
      }

      this.sendLoading = true
      onCall(data)
      .then((result) => {
        console.log('Test DM Succsess! ', result)
        self.sendLoading = false
        self.$ons.notification.alert('投稿しました！<br><br>Twitterアカウントのタイムラインを<br>確認してください。')
      })
      .catch(function (err) {
        console.log('Error DM Tweet: ', err)
        self.sendLoading = false
        self.$ons.notification.alert('送信エラー！<br>', err)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/com_twitter.js